module.exports = __webpack_public_path__ + "img/Frage1_2048x1536.30ff5333.jpg";